import { StepEntity } from '../entities/step-entity';

export default class State {
  steps: Array<StepEntity> = [];
}
